export const MODULE_CONTACT = 'contacts'
export const MODULE_LEAD = 'leads'
export const MODULE_ALL = 'all'
export const MODULE_ACCOUNT = 'accounts'
